import * as React from "react";
import { cn } from "../../lib/utils";

export type ButtonGroupProps = React.HTMLAttributes<HTMLDivElement>

const ButtonGroup = React.forwardRef<HTMLDivElement, ButtonGroupProps>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "inline-flex items-center rounded-md shadow-sm",
          "[&>button]:rounded-none [&>button]:border-r-0 [&>button:first-child]:rounded-l-md [&>button:last-child]:rounded-r-md [&>button:last-child]:border-r",
          "[&>:first-child]:rounded-l-md [&>:last-child]:rounded-r-md [&>:not(:first-child):not(:last-child)]:rounded-none",
          "[&>*:not(:last-child)]:border-r-0",
          className
        )}
        {...props}
      />
    );
  }
);
ButtonGroup.displayName = "ButtonGroup";

export { ButtonGroup };
